import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormPc003Filter } from 'src/app/entity/models/form-pc003-filter';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { GeneralFilterComponent } from 'src/app/shared/general-filter.component';


@Component({
  selector: 'app-filter-pc003-estrategia',
  templateUrl: './filter-pc003-estrategia.component.html',
  styleUrls: ['./filter-pc003-estrategia.component.scss']
})
export class FilterPc003EstrategiaComponent extends GeneralFilterComponent implements OnInit {
  public formulario?: FormGroup;
  public listSafra?: DropDownListDTO[];
  public listAno?: DropDownListDTO[];
  public listHibridoRnc?: DropDownListDTO[];
  public filteredOptionsSafra: Observable<DropDownListDTO[]>;
  public filteredOptionsAno: Observable<DropDownListDTO[]>;
  public filteredOptionsHibrido: Observable<DropDownListDTO[]>;


  @Output() filter = new EventEmitter();
  constructor(protected formBuilder: FormBuilder, protected formularioService: FormularioService,
    // tslint:disable-next-line: align
    protected notificationService: NotificationService, protected generalService: GeneralService) {
    super();
    this.formulario = this.formBuilder.group({
      hibrido_rnc: ['', []],

    });
  }

  async ngOnInit(): Promise<void> {
    this.listSafra = new Array<DropDownListDTO>();
    this.listHibridoRnc = new Array<DropDownListDTO>();

    await this.getLists();
    await this.getFilters();
  }

  async sendFilter(): Promise<void> {
    this.filter.emit(await this.buildFilter());
  }

  async clearFilter(): Promise<void> {
    this.formulario.reset();
    this.formulario.get('site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
    await this.getFilters();
  }

  async buildFilter(): Promise<FormPc003Filter> {
    const formulario: FormPc003Filter = new FormPc003Filter();


    formulario.hibrido_rnc = this.formulario.get('hibrido_rnc')?.value ?? '';
    return formulario;
  }

  async getLists(): Promise<void> {
    await Promise.all([this.getListHibrido()]);
  }




  async getListHibrido(): Promise<void> {
    await this.formularioService.getListDropDownList('qua007', 'hibrido_rnc').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listHibridoRnc = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
    });
  }
  async getFilters(): Promise<void> {
    await Promise.all([this.createFilterHibrido()])
  }


  createFilterHibrido(): void {
    this.filteredOptionsHibrido = this.formulario.get('hibrido_rnc').valueChanges
      .pipe(
        startWith(''),
        map(value => this.generalService._filterDropDownList(this.listHibridoRnc, value))
      );
  }

}
